import zustand from 'zustand'
import { UsersStoreState } from '../types'

/**
 * Zustand store for managing users search state
 * Maintains filter, input, fetched documents, and report data
 */
export const useSearchStore = zustand<UsersStoreState>(() => ({
  input: '',
  docs: [],
  hasMore: true,
  reports: {},
}))

/**
 * Zustand store for managing users list state
 * Separate from search to maintain independent state
 */
export const useListStore = zustand<UsersStoreState>(() => ({
  input: '',
  docs: [],
  hasMore: true,
  reports: {},
}))
